
import Search from 'vux/src/components/search/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'

import {promptMessage,fetch,baseUrl} from '@/api/dataHandling';
import axios from 'axios';
import {urlConfig} from '@/api/urlConfig';
import {getken} from '@/api/getToken';
export default {
data(){
return{
listData:[],
searchValue:''
}

},
components: {
Search,XButton
},
methods:{
search(){
let contentData = JSON.parse(this.contentDataString);
if(this.searchValue){
this.searchValue = this.searchValue.trim();
this.listData =[];
for(let i=0;i<contentData.length;i++){
if(contentData[i].remark1.indexOf(this.searchValue) !=-1 || contentData[i].szdCmc.indexOf(this.searchValue) !=-1){
this.listData.push(contentData[i]);
}
}
}else{
this.listData = contentData;
}
},
getData(){
axios.defaults.headers.common['Authorization'] = window.localStorage.getItem('token')
axios.get(baseUrl + urlConfig.getzd+'10141').then(response => {
console.log(response.data,44333)
this.listData = response.data;
this.contentDataString = JSON.stringify(response.data);
this.$store.commit('updateLoadingStatus',{isLoading:false});
}).catch(error => {

})
}

},
mounted() {
getken(this.getData);
}
}



// WEBPACK FOOTER //
// ./src/project/articleProject/hospitalAddress.vue